module.exports = __webpack_public_path__ + "static/img/Josh-Addo-Carr.f6ab098.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Josh-Addo-Carr.jpg
// module id = Dv6h
// module chunks = 0